<template>
  <div>
    <SlideShowSection :items="slidesHome" :loading="loadingSlidesHome" />
    <MrtSection />
    <AwardsSection />
    <ArticlesSection />
    <!-- <ServicesSection /> -->
    <StatisticsSection />
    <VideosSection />
    <MaterialsSection :itemsPerPage="12" />
    <!-- <CoprocessedWasteSection :itemsPerPage="15" /> -->
  </div>
</template>

<script>
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import MrtSection from "../components/sections/MrtSection.vue";
import AwardsSection from "../components/sections/AwardsSection.vue";
import ArticlesSection from "../components/sections/ArticlesSection.vue";
// import ServicesSection from "../components/sections/ServicesSection.vue";
import StatisticsSection from "../components/sections/StatisticsSection.vue";
import VideosSection from "../components/sections/VideosSection.vue";
import MaterialsSection from "../components/sections/MaterialsSection.vue";
// import CoprocessedWasteSection from "../components/sections/CoprocessedWasteSection.vue";

export default {
  data: () => ({
    loadingSlidesHome: true,
    slidesHome: [],
  }),

  created() {
    this.$rest("slides")
      .get()
      .then((bufferedSlides) => {
        this.slidesHome = bufferedSlides;
      })
      .then(() => (this.loadingSlidesHome = false));
  },
  components: {
    SlideShowSection,
    MrtSection,
    AwardsSection,
    ArticlesSection,
    // ServicesSection,
    StatisticsSection,
    VideosSection,
    MaterialsSection,
    // CoprocessedWasteSection,
  },
};
</script>
